import React from 'react'
import { LuTriangleAlert } from 'react-icons/lu'

import { useCurrentCompany } from '@/hooks/useCurrentCompany'

const ImportingCompanyMissingWarning: React.FC = () => {
  const currentCompany = useCurrentCompany()
  return (
    <>
      <span className="text-destructive block text-xs">
        <LuTriangleAlert className="mr-1 inline-block" />
        Your company ({currentCompany?.presentationName}) must be included in at
        least one side of the referral — either ‘Introduced by’ or ‘Introduced
        to’. This row doesn’t meet that requirement. Please update and try
        again.
      </span>
    </>
  )
}

export default ImportingCompanyMissingWarning
